import ViewportActionCorners, { ViewportActionCornersLocations } from './ViewportActionCorners';

export { ViewportActionCornersLocations };
export default ViewportActionCorners;
